module.exports = __webpack_public_path__ + "static/img/defaultWorkCover.523fd01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defaultWorkCover.png
// module id = /3wT
// module chunks = 0